<div class="notice-wrapper yellow">
  <i class="k-icon k-font-icon k-i-info"></i>
  <ng-content></ng-content>
</div>
